import React from 'react'

import { isItemAvailable } from 'src/utils/product'
import AddToCart from 'src/components/Product/AddToCart/AddToCart'
import VariantSelect from 'src/components/Product/VariantSelect/VariantSelect'

import styles from '../Product.module.scss'

type Props = {
  items: any
  cart: any
  fetched: boolean
  setActiveVariant: any
  activeVariant: any
  extra?: boolean
}

const ShopSection = ({
  items,
  cart,
  fetched,
  setActiveVariant,
  activeVariant,
  extra,
}: Props) => {
  const gotVariants = items && items.length > 1
  return (
    <div className={gotVariants ? styles.shopSection : styles.shopNoVariants}>
      {gotVariants && (
        <VariantSelect
          key={fetched ? 1 : 2}
          items={items.map((item: any) => ({
            ...item,
            disabled: !isItemAvailable(cart.country, item.stock),
          }))}
          selected={activeVariant}
          onChange={(variant: any) => setActiveVariant(variant, extra)}
        />
      )}
      <AddToCart
        disabled={
          !isItemAvailable(
            cart.country,
            activeVariant ? activeVariant.stock : {}
          )
        }
        variant={activeVariant}
      />
    </div>
  )
}

export default ShopSection
